import React from 'react';
const Context = /*#__PURE__*/React.createContext({});
export { Context };